// Central data for Hasan Javed Glass & Aluminum LLC website

export const COMPANY = {
  name: "Hasan Javed Glass & Aluminium Installation LLC",
  shortName: "Hasan Javed",
  subtitle: "Glass & Aluminium Installation LLC",
  logo: "/logo-emblem.png",
  location: "Fatima Thani Building, Shop 11, 11th Street, Naif, Deira, Dubai, UAE",
  locationShort: "Naif, Deira, Dubai — UAE",
  phone: "+971 55 8430513",
  phoneRaw: "+971558430513",
  email: "rajamansoor865@gmail.com",
  whatsapp: "971558430513",
  hours: "Mon – Sat · 8:00 AM – 10:00 PM",
  tagline: "Premium Glass & Aluminum Solutions in the UAE",
  instagram: "https://www.instagram.com/glass_aluminium_work",
  instagramHandle: "@glass_aluminium_work",
  mapsQuery: "Fatima+Thani+Building+Shop+11+11th+Street+Naif+Deira+Dubai",
  mapsLink: "https://maps.google.com/?q=Fatima+Thani+Building+Shop+11+11th+Street+Naif+Deira+Dubai",
};

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Portfolio", href: "#portfolio" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "Contact", href: "#contact" },
];

export const SERVICES = [
  { name: "Glass Installation", icon: "PanelsTopLeft", desc: "Precision-fitted architectural glass for facades and interiors." },
  { name: "Glass Replacement & Repair", icon: "Wrench", desc: "Fast, clean replacement of broken and damaged glass panels." },
  { name: "Shower Enclosures", icon: "Bath", desc: "Frameless and semi-frameless enclosures crafted to the millimeter." },
  { name: "Glass Staircase Railings", icon: "MoveVertical", desc: "Structural glass railings with stainless or minimalist hardware." },
  { name: "Glass Balustrades", icon: "Fence", desc: "Balcony and terrace balustrades — code-compliant and elegant." },
  { name: "Office Glass Partitions", icon: "Columns3", desc: "Single, double glazed and acoustic partitions for workspaces." },
  { name: "Aluminum Doors & Windows", icon: "DoorOpen", desc: "Thermally-broken systems for residential and commercial buildings." },
  { name: "Sliding & Folding Systems", icon: "MoveHorizontal", desc: "Slim-profile sliding, bi-fold, and lift-and-slide door systems." },
  { name: "Custom Mirrors", icon: "Frame", desc: "Bespoke mirrors cut, beveled and finished to your specification." },
  { name: "Antique Mirrors", icon: "Sparkles", desc: "Aged, smoked and patterned mirrors for hospitality interiors." },
  { name: "LED Mirrors", icon: "Lightbulb", desc: "Backlit, anti-fog, touch-controlled bathroom and vanity mirrors." },
  { name: "Decorative Mirrors", icon: "Palette", desc: "Signature feature walls and statement mirror installations." },
  { name: "Gym Mirrors", icon: "Dumbbell", desc: "Distortion-free large-format mirrors for studios and gyms." },
  { name: "Black Film Installation", icon: "Layers", desc: "Solar, privacy and safety films professionally applied." },
  { name: "Glass Maintenance & Repair", icon: "Settings2", desc: "Scheduled service to keep your glazing crystal-clear." },
  { name: "Emergency Glass Replacement", icon: "Zap", desc: "24/7 rapid response for broken windows and storefronts." },
  { name: "Joinery Works", icon: "Hammer", desc: "Bespoke wood joinery integrated with glass and aluminum." },
  { name: "Kitchen Cabinets", icon: "ChefHat", desc: "Modern, durable kitchen cabinetry with premium hardware." },
  { name: "Aluminum Doors", icon: "SquareStack", desc: "Robust aluminum door systems for every entrance type." },
  { name: "Gypsum Works", icon: "Grid3X3", desc: "Ceiling, wall and partition gypsum work with clean finishes." },
];

export const WHY_US = [
  { title: "Experienced Professionals", desc: "A senior team of glazers, fabricators and installers with decades of combined field experience.", metric: "15+", metricLabel: "Years combined" },
  { title: "High-Quality Materials", desc: "We work exclusively with certified glass, aluminum systems and hardware from trusted global brands.", metric: "A+", metricLabel: "Grade materials" },
  { title: "Precision Installation", desc: "Millimeter-accurate site surveys, digital templating and meticulous finishing on every job.", metric: "0.5mm", metricLabel: "Tolerance" },
  { title: "Competitive Pricing", desc: "Transparent, itemized quotations with no hidden costs — value engineered from day one." },
  { title: "Fast Project Completion", desc: "Streamlined logistics and dedicated site teams that deliver on schedule, every time." },
  { title: "Customized Solutions", desc: "Every brief is tailored — from single-unit repairs to full-building glazing packages." },
  { title: "Reliable After-Sales Support", desc: "Warranty-backed workmanship and responsive service long after installation." },
  { title: "Serving All Emirates", desc: "Dubai, Abu Dhabi, Sharjah, Ajman, Ras Al Khaimah, Fujairah and Umm Al Quwain." },
];

export const PORTFOLIO = [
  {
    src: "/projects/staircase-led.jpg",
    title: "Illuminated Glass Staircase & Balustrade",
    tag: "Luxury Residence",
    span: "col-span-2 row-span-2",
  },
  {
    src: "/projects/aluminum-french-doors.jpg",
    title: "Aluminum French Doors, Villa Terrace",
    tag: "Residential",
    span: "col-span-2 row-span-1",
  },
  {
    src: "/projects/led-mirrors.jpg",
    title: "Twin LED Mirrors on Onyx Marble",
    tag: "Residential",
    span: "col-span-1 row-span-2",
  },
  {
    src: "/projects/shower-marble.jpg",
    title: "Frameless Shower Enclosure, Marble Bath",
    tag: "Residential",
    span: "col-span-1 row-span-2",
  },
  {
    src: "/projects/office-partition.jpg",
    title: "Framed Office Glass Partition",
    tag: "Commercial",
    span: "col-span-2 row-span-1",
  },
  {
    src: "/projects/greek-key-staircase.jpg",
    title: "Greek-Key Etched Staircase Balustrade",
    tag: "Luxury Residence",
    span: "col-span-2 row-span-2",
  },
  {
    src: "/projects/kitchen-doors.jpg",
    title: "Black-Frame Sliding Kitchen Doors",
    tag: "Residential",
    span: "col-span-1 row-span-2",
  },
  {
    src: "/projects/bathroom-partitions.jpg",
    title: "Framed Glass Bathroom Partitions",
    tag: "Luxury Residence",
    span: "col-span-1 row-span-2",
  },
  {
    src: "/projects/louvered-shutters.jpg",
    title: "Aluminum Louvered Shutters, Villa",
    tag: "Residential",
    span: "col-span-2 row-span-2",
  },
  {
    src: "/projects/conservatory.jpg",
    title: "Villa Glass & Aluminium Conservatory",
    tag: "Residential",
    span: "col-span-1 row-span-2",
  },
  {
    src: "/projects/panelled-mirror.jpg",
    title: "Panelled Mirror on Marble Feature Wall",
    tag: "Luxury Residence",
    span: "col-span-1 row-span-2",
  },
  {
    src: "/projects/wooden-tv-joinery.jpg",
    title: "Wooden TV Joinery with LED-Lit Shelves",
    tag: "Joinery",
    span: "col-span-2 row-span-2",
  },
  {
    src: "/projects/awning-windows.jpg",
    title: "Aluminum Awning Windows, 5-Panel",
    tag: "Residential",
    span: "col-span-1 row-span-2",
  },
  {
    src: "/projects/glass-partition-door.jpg",
    title: "Frameless Glass Partition Door",
    tag: "Commercial",
    span: "col-span-1 row-span-2",
  },
  {
    src: "/projects/arched-window.jpg",
    title: "Arched Aluminum Window, Tinted Glazing",
    tag: "Residential",
    span: "col-span-2 row-span-1",
  },
];

export const TESTIMONIALS = [
  {
    quote: "The team delivered a stunning frameless glass staircase for our villa. Precision, punctuality and finish were world-class.",
    name: "Ahmad Al-Marri",
    role: "Villa Owner, Jumeirah",
  },
  {
    quote: "We fitted out 22 offices across two floors with their acoustic partitions. Zero snags, delivered two days ahead of schedule.",
    name: "Priya Nair",
    role: "Head of Facilities, DIFC Tenant",
  },
  {
    quote: "Called them at 11pm for an emergency shopfront replacement. They arrived within the hour and reopened us by morning.",
    name: "Mohammed Hussain",
    role: "Retail Manager, Deira",
  },
  {
    quote: "The LED mirrors and shower enclosures completely transformed our master bathrooms. Craftsmanship you can feel.",
    name: "Sarah Thompson",
    role: "Interior Designer, Dubai Marina",
  },
];
